import React from "react";
import { connect } from "react-redux";
import { Creators, getCurrentRegistration } from "./reducer";

/*
HOC that provides shared Registration Step functionality
 */
const registrationStep = (WrappedComponent, step, nextStep) => {
  class RegistrationStep extends React.Component {
    constructor(props) {
      super(props);

      this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(data) {
      const {
        currentRegistrationId,
        currentRegistration,
        updateRegistration,
        createRegistration,
        completeRegistration,
        cancelRegistration,
        history
      } = this.props;

      // Clone data here so we aren't interacting with state
      const toSend = { ...data };

      // To determine where to go next use the following priority:
      //
      // 1. If the submit data includes a nextStep
      // 2. If the component is registered with a nextStep
      // 3. Use the current step
      //
      // If we have nextStep on the data make sure to remove it.
      toSend.step = toSend.nextStep || nextStep || step;
      delete toSend.nextStep;

      // If we are changing steps, mark the current step complete by adding it
      // to a completedSteps array.
      if (toSend.step !== step && currentRegistration) {
        toSend.completedSteps = currentRegistration.completedSteps
          ? Array.from(currentRegistration.completedSteps)
          : [];
        toSend.completedSteps.push(step);
      }

      if (!currentRegistrationId) {
        createRegistration(toSend);
      } else {
        if (toSend.cancel) {
          cancelRegistration(currentRegistrationId);
          history.push("/registration/start");
          return;
        }

        if (toSend.completed) {
          delete toSend.step;
        }

        updateRegistration(currentRegistrationId, toSend);

        if (toSend.completed) {
          completeRegistration(currentRegistrationId);
          history.push("/registration/start");
        }
      }
    }

    render() {
      return <WrappedComponent {...this.props} onSubmit={this.handleSubmit} />;
    }
  }

  return connect(
    state => ({
      currentRegistrationId: state.registration.currentRegistrationId,
      currentRegistration: getCurrentRegistration(state),
      steps: state.registration.steps,
      selectedLocation: state.login.location
    }),
    dispatch => ({
      createRegistration: data => dispatch(Creators.createRegistration(data)),
      updateRegistration: (id, data) =>
        dispatch(Creators.updateRegistration(id, data)),
      completeRegistration: id => dispatch(Creators.completeRegistration(id)),
      cancelRegistration: id => dispatch(Creators.cancelRegistration(id)),
      completeStep: step => dispatch(Creators.stepComplete(step))
    })
  )(RegistrationStep);
};

export default registrationStep;



// WEBPACK FOOTER //
// ./src/registration/registrationStep.js